import { render } from "./app-button-business.vue?vue&type=template&id=64af353e&scoped=true"
import script from "./app-button-business.vue?vue&type=script&lang=js"
export * from "./app-button-business.vue?vue&type=script&lang=js"

import "./app-button-business.vue?vue&type=style&index=0&id=64af353e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64af353e"],['__file',"src/views/components/button/app-button-business.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64af353e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64af353e', __exports__)) {
    console.log('reload')
    api.reload('64af353e', __exports__)
  }
  
  module.hot.accept("./app-button-business.vue?vue&type=template&id=64af353e&scoped=true", () => {
    console.log('re-render')
    api.rerender('64af353e', render)
  })

}


export default __exports__